import Vue from 'vue';

Vue.component('vuetable-drawer-check', () =>
    import(/* webpackChunkName: 'drawer-check-index' */ './vuetable-drawer-check.vue'),
);
